import React, { useEffect, useState } from 'react';

import styles from './Place.module.css';

import { useTranslation } from 'react-i18next';

import Form from './Form';
import Managment from './Managment';
import Top from './Top';

import cn from 'classnames';

import { useForm } from '@mantine/form';

import { Button } from '@mantine/core';
import GlobeWhite from '@icons/GlobeWhite.svg';
import Globe from '@icons/Globe.svg';
import ManagmentWhite from '@icons/ManagmentWhite.svg';
import ManagmentSvg from '@icons/Managment.svg';

import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import useAuth from '@hooks/useAuth';

const Place = ({ place, handleSubmit }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [{ currentUser }] = useAuth();

  useEffect(() => {
    window.gtag('event', 'open_place_page', {
      isAdmin: !!currentUser?.admin
    })
  }, [])

  let pageInitial = 'common';
  let isOrganization = false
  let isCalledFromMain = false
  let organization = ''

  for (const entry of searchParams.entries()) {
    const [param, value] = entry;

    if (param === 'page') {
      pageInitial = value
    }

    if (param === 'organization') {
      organization = value
    }

    if (param === 'main') {
      isCalledFromMain = value
    }

    if (param === 'isOrganization') {
      isOrganization = value
    }
  }

  const [page, setPage] = useState(pageInitial);

  const handleSetPage = (value) => {
    setPage(value);
    const organizationQuery = !!organization ? `&organization=${organization}` : '';
    const isOrganizationQuery = !!isOrganization ? `&isOrganization=${isOrganization}` : '';
    const mainQueryParam = !!isCalledFromMain ? `&main=${isCalledFromMain}`: '';
    navigate(`/places/${id}?page=${value}${organizationQuery}${isOrganizationQuery}${mainQueryParam}`, { replace: true })
  }

  const {
    place: {
      placeName,
      placeAddress,
      type,
      image,
      vip,
      logo,
    },
    info
  } = place;

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      placeName,
      placeAddress,
      type,
      image,
      logo,
      description: info?.description,
      schedule: info?.schedule,
      phone: info?.phone,
      social: info?.social,
      site: info?.site,
      copyright: info?.copyright
    },

    validate: {
      image: (value) => {
        if (!value) {
          return false;
        }

        const fileSize = value.size / 1024 / 1024;

        if (fileSize > 1) {
          return t('errors.image.size')
        }

        return false
      },

      logo: (value) => {
        if (!value) {
          return false;
        }

        const fileSize = value?.size / 1024;

        if (fileSize > 512) {
          return t('errors.logo.size')
        }

        return false
      }
    },
  });

  return (
    <div className={styles.wrapper}>
      <form
        onSubmit={form.onSubmit(handleSubmit)}
      >
        <div className={styles.top}>
          <Top
            isOrganization={isOrganization}
            isCalledFromMain={isCalledFromMain}
            place={place}
            form={form}
            onSubmit={handleSubmit}
            vip={vip}
            organization={organization}
          />
        </div>

        <div className={styles.content}>
          <div className={styles.menu}>
            <Button
              leftSection={<img src={page === 'common' ? GlobeWhite : Globe} />}
              fullWidth
              justify='left'
              className={cn(styles.button, page === 'common' && styles.active)}
              onClick={() => handleSetPage('common')}
            >
              {t('common')}
            </Button>

            {currentUser.admin && (
              <Button
                leftSection={<img src={page === 'management' ? ManagmentWhite : ManagmentSvg} />}
                fullWidth
                justify='left'
                className={cn(styles.button, page === 'management' && styles.active)}
                onClick={() => handleSetPage('management')}
              >
                {t('management')}
              </Button>
            )}
          </div>

          <div className={styles.form}>
            {place && page === 'common' && <Form place={place} form={form} />}

            {page === 'management' && <Managment id={id} />}
          </div>
        </div>
      </form>
    </div >
  )
}

export default Place;
